import { App } from "antd";
import { useEffect } from "react";

let notificationApi;

export const NotificationInit = () => {
  const { notification } = App.useApp();
  useEffect(() => {
    notificationApi = notification;
  }, [notification]);
  return null;
};

export const showErrorNotification = (errorObject) => {
  const { errorType, message } = errorObject?.response?.data || {
    errorType: "Internal Server Error",
    message: "Internal Server Error"
  };
  showNotification(errorType, message, "error");
};

export const showSuccessNotification = (successMessage) => {
  showNotification(successMessage, successMessage, "success");
};

export const showWarningNotification = (warningMessage) => {
  showNotification(warningMessage, warningMessage, "warning");
};

export const showNotification = (name, message, status, placement = "bottomLeft") => {
  // Fallback to static if context not ready (though it might warn)
  const api = notificationApi;

  if (!api) {
    console.warn("Notification API not yet initialized, notification skipped or logged:", message);
    return;
  }

  api.destroy();

  if (status === "success") {
    api.success({
      message: name,
      description: message,
      placement
    });
  } else if (status === "error") {
    api.error({
      message: name,
      description: message,
      placement
    });
  } else if (status === "warning") {
    api.warning({
      message: name,
      description: message,
      placement
    });
  }
};
